module.exports = __webpack_public_path__ + "static/media/logo_20_anhos_mobile.26d5e7a3.webp";